import { Injectable } from '@angular/core';
import { SponsorConfig } from '../interface/sponsor-config.interface';

@Injectable()
export class SponsorConfigService {
    constructor(
    ) { }

    /**
    * @description this method will get the config settings for combo packs page
    * @date 2019-09-16
    * @memberof SponsorConfigService
    */
    public getSettings(countryCode: string): SponsorConfig {
        let sponsorConfig: SponsorConfig;
        switch (countryCode.toUpperCase()) {
            case 'USA':
                sponsorConfig = this.loadUSASettings();
                break;
            case 'CAN':
                sponsorConfig = this.loadCANSettings();
                break;
            case 'GBR':
                sponsorConfig = this.loadGBRSettings();
                break;
            case 'ARE':
                sponsorConfig = this.loadARESettings();
                break;
            case 'SAU':
                sponsorConfig = this.loadSAUSettings();
                break;
            case 'QAT':
                sponsorConfig = this.loadQATSettings();
                break;
            case 'IRL':
                sponsorConfig = this.loadIRLSettings();
                break;
            case 'ILN':
                sponsorConfig = this.loadILNSettings();
                break;
            case 'KWT':
                sponsorConfig = this.loadKWTSettings();
                break;
            case 'BHR':
                sponsorConfig = this.loadBHRSettings();
                break;
            case 'OMN':
                sponsorConfig = this.loadOMNSettings();
                break;
            case 'AUS':
                sponsorConfig = this.loadAUSSettings();
               break;
            case 'NZL':
                sponsorConfig = this.loadNZLSettings();
               break;
            case 'POL':
               sponsorConfig = this.loadPOLSettings();
               break;
               case 'BEL':
               sponsorConfig = this.loadBELSettings();
               break;
               case 'LUX':
               sponsorConfig = this.loadLUXSettings();
               break;
               case 'NLD':
               sponsorConfig = this.loadNLDSettings();
               break;
            case 'SWE':
                sponsorConfig = this.loadSWESettings();
                break;
            case 'DNK':
                sponsorConfig = this.loadDNKSettings();
                break;
            case 'FIN':
                sponsorConfig = this.loadFINSettings();
                break;
            case 'NOR':
                sponsorConfig = this.loadNORSettings();
                break;
            case 'DEU':
                sponsorConfig = this.loadDEUSettings();
                break;
            case 'AUT':
                sponsorConfig = this.loadAUTSettings();
                break;
            case 'CHE':
                sponsorConfig = this.loadCHESettings();
                break;
            case 'ISL':
                sponsorConfig = this.loadISLSettings();
                break;
            case 'BGR':
                sponsorConfig = this.loadBGRSettings();
                break;
            case 'MKD':
                sponsorConfig = this.loadMKDSettings();
                break;
            case 'TZA':
                sponsorConfig = this.loadTZASettings();
                break;
            case 'SEN':
                sponsorConfig = this.loadSENSettings();
                break;
            default:
                sponsorConfig = this.loadUSASettings();
                break;
        }
        return sponsorConfig;
    }

    /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadUSASettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'USA',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch:false
        };
        return sponsorConfig;
    }

    /**
     * @description this method will return CAN settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadCANSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'CAN',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch:false
        };
        return sponsorConfig;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadGBRSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'GBR',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: true,
            displayIDontHaveSponsorGuestSection: true,
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch:false
        };
        return sponsorConfig;
    }
    /**
     * @description this method will return ARE settings
     * @date 2020-05-20
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadARESettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'ARE',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch:false
        };
        return sponsorConfig;
    }
     /**
     * @description this method will return SAU settings
     * @date 2020-07-28
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadSAUSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'SAU',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch:false
        };
        return sponsorConfig;
    }

    /**
     * @description returns QAT sponsor settings
     * @author njagadeesan
     * @date 2020-11-24
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadQATSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'QAT',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }

      /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadIRLSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'IRL',
            hideSponsorStateDropdownCountires: ['IRL'],
            loadSponsorWizardInGuestFlow: true,
            displayIDontHaveSponsorGuestSection: true,
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch:true
        };
        return sponsorConfig;
    }

      /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadILNSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'ILN',
            hideSponsorStateDropdownCountires: ['ILN'],
            loadSponsorWizardInGuestFlow: true,
            displayIDontHaveSponsorGuestSection: true,
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch:false
        };
        return sponsorConfig;
    }


    /**
     * @description this method will return KWT session 
     * @author Akhil
     * @date 2020-12-16
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadKWTSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'KWT',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }

    /**
     * @description this method will return BHR settings
     * @date 2021-02-11
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadBHRSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'BHR',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }

    /**
     * @description this method will return OMN settings
     * @date 2021-03-08
     * @private
     * @returns {AppConfigSetting}
     * @memberof AppConfigService
     */
    private loadOMNSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'OMN',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }
    
    /**
     * @description this method will return AUS settings 
     * @author Akhil
     * @date 2021-03-15
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadAUSSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'AUS',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }
     /**
     * @description this method will return AUS settings 
     * @author Akhil
     * @date 2021-03-15
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
      private loadNZLSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'NZL',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }


    /**
     * @description this method will return POL Settings
     * @author Akhil
     * @date 2021-05-18
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadPOLSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'POL',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }

    private loadBELSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'BEL',
            hideSponsorStateDropdownCountires: ['GBR'],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

    private loadLUXSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
        countryCode: 'LUX',
        hideSponsorStateDropdownCountires: ['GBR'],
        isSponsorSearchByArea: false,
        addressIdForSponsorSearch: false,
        sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

    private loadNLDSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'NLD',
            hideSponsorStateDropdownCountires: ['GBR'],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

        
     /**
     * @description this method will return PMKDOL settings 
     * @date 2022-10-18
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadSWESettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'SWE',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

     /**
     * @description this method will return PMKDOL settings 
     * @date 2022-10-18
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadDNKSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'DNK',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

     /**
     * @description this method will return PMKDOL settings 
     * @date 2022-10-18
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadFINSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'FIN',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

    /**
     * @description this method will return PMKDOL settings 
     * @date 2022-10-18
     * @private
     * @returns {SponsorConfig}
     * @memberof SponsorConfigService
     */
    private loadNORSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'NOR',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }
    private loadDEUSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'DEU',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }
    private loadAUTSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'AUT',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }
    private loadBGRSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'BGR',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

    private loadMKDSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'MKD',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }

    private loadCHESettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'CHE',
            hideSponsorStateDropdownCountires: [],
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: false,
            sponsorCityFieldRequired: true
        };
        return sponsorConfig;
    }
    private loadISLSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'ISL',
            hideSponsorStateDropdownCountires: ['ISL'],
            loadSponsorWizardInGuestFlow: true,
            displayIDontHaveSponsorGuestSection: true,
            isSponsorSearchByArea: false,
            addressIdForSponsorSearch: true
        };
        return sponsorConfig;
    }

    private loadTZASettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'TZA',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }

    private loadSENSettings(): SponsorConfig {
        const sponsorConfig: SponsorConfig = {
            countryCode: 'SEN',
            hideSponsorStateDropdownCountires: ['GBR'],
            loadSponsorWizardInGuestFlow: false,
            displayIDontHaveSponsorGuestSection: false,
            isSponsorSearchByArea: true,
            addressIdForSponsorSearch: false
        };
        return sponsorConfig;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/sponsor-config.service.ts